import { AbstractControl, ValidationErrors } from '@angular/forms';

export class CustomValidators {
    /**
     * Validator that rejects names containing numbers
     */
    static noNumbers(control: AbstractControl): ValidationErrors | null {
        if (!control.value) return null;
        return /\d/.test(control.value) ? { hasNumbers: true } : null;
    }

    /**
     * Validator for phone numbers - requires at least 10 digits
     * Accepts spaces, dashes, parentheses, dots, and optional + prefix
     */
    static phone(control: AbstractControl): ValidationErrors | null {
        if (!control.value) return null;

        const cleanPhone = control.value.replace(/[\s\-\(\)\.]/g, '');
        const digitsOnly = cleanPhone.replace(/\+/g, '');

        // Check if contains only digits and optional +
        if (!/^[\+]?[0-9]+$/.test(cleanPhone)) {
            return { invalidPhone: true };
        }

        // Check minimum 10 digits
        if (digitsOnly.length < 10) {
            return { invalidPhone: true };
        }

        return null;
    }

    /**
     * Validator for Italian fiscal code - 11 to 16 characters
     */
    static fiscalCode(control: AbstractControl): ValidationErrors | null {
        if (!control.value) return null;

        const fc = control.value.trim().toUpperCase();

        if (fc.length < 11 || fc.length > 16) {
            return { invalidFiscalCode: true };
        }

        return null;
    }
}
